module.exports = __webpack_public_path__ + "img/24_hr_emergency_assistance.d1a9a44e.webp";